<template>
  <div
    class="accordion accordion-solid accordion-toggle-plus"
    id="accordion-form-robot"
  >
    <div class="card m-3">
      <div class="card-header">
        <div
          class="card-title collapsed py-3 pr-10 font-weight-normal"
          data-toggle="collapse"
          data-target="#collapse_google_search"
        >
          <span>
            {{ $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_GOOGLE_SEARCH.TITLE") }}
          </span>
        </div>
      </div>

      <div
        id="collapse_google_search"
        class="collapse"
        data-parent="#accordion-form-robot"
      >
        <div class="card-body">
          <div
            v-if="hasAccess('robotsGoogleVerificationOwner', 'read')"
            class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3"
          >
            <label class="mr-2 w-25">{{
              $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_GOOGLE_SEARCH.LABEL_ROBOTS")
            }}</label>

            <div class="d-flex flex-column w-75">
              <b-form-textarea
                v-model="form.robotsGoogleVerificationOwner"
                :placeholder="
                  $tc(
                    'ADVANCED_SETTINGS.DOMAIN.CONFIG_GOOGLE_SEARCH.LABEL_ROBOTS'
                  )
                "
                class="form-control--grey"
                rows="8"
                :disabled="!hasAccess('robotsGoogleVerificationOwner', 'write')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/store/auth.module";
import { getAttributesRead, hasAttributeAccess } from "@/common/config/acl";
import { FORM_GOOGLE_SEARCH } from "@/common/config/acl/domain/googleSearch";
import { stringifyJson } from "@/assets/js/helper";

export default {
  props: {
    domainId: {
      type: String,
      required: false
    },
    formProps: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      user: auth.state.user,
      form: getAttributesRead(FORM_GOOGLE_SEARCH, auth.state.user.roles)
    };
  },

  mounted() {
    if (this.domainId) {
      this.form.robotsGoogleVerificationOwner = stringifyJson(
        this.formProps.robotsGoogleVerificationOwner
      );
    }
  },

  methods: {
    hasAccess(field, accessType) {
      return hasAttributeAccess(
        FORM_GOOGLE_SEARCH,
        this.user.roles,
        field,
        accessType
      );
    },
    resetData() {
      this.form = getAttributesRead(FORM_GOOGLE_SEARCH, this.user.roles);
    }
  }
};
</script>
